import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom'
import avater from '../../../assets/img/common/avater.png'
import iosicon from '../../../assets/img/custom/ios-icon.png'
import androidicon from '../../../assets/img/custom/android-icon.png'

import fb from '../../../assets/img/custom/social/fb.png'
import twitter from '../../../assets/img/custom/social/twitter.png'
import yt from '../../../assets/img/custom/social/yt.png'
import linked from '../../../assets/img/custom/social/linked.png'
import insta from '../../../assets/img/custom/social/insta.png'

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom"
import Swal from 'sweetalert2';
import { AuthContext } from '../../../context/AuthContext'
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import Cookies from 'js-cookie'
import { IoCallOutline, IoMailOutline } from "react-icons/io5";

const TopHeader = (props) => {
    const {getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const { t, i18n } = useTranslation();
 
    const authUser = getAuthUser()
    const branch =getCurrentBranch()
    const history = useHistory()

    let status = useSelector((state) => state.user.status);
    let user = useSelector((state) => props.authUser);
    const [currentBranch, setCurrentBranch] = useState(branch);
    const [currentLang, setCurrentLang] = useState(Cookies.get('fj_lang') || 'en');

    useEffect(() => {
            if(props.branches.length && !branch){
                localStorage.setItem('currentBranch', props.branches[0].id)
                setCurrentBranch(props.branches[0].id)
            }

    
      }, [props.branches]);

      useEffect(() => {
        if(currentBranch?.length){
            if(isAuthenticated()){
                const onSuccess = (res) => {
                 
                    switch (props.location.pathname) {
                        case '/':
                            props.fetchRandomPackages({branch: currentBranch, status: 'active'})
                            props.fetchFeaturedServices({ branch: currentBranch, status: 'active', featured: true });
                          break;
                        case '/estore':
                            const onSuccess = () => {
                   
                            }
                            props.fetchServices({branch:currentBranch,type:props.location.state.type,status: 'active'},onSuccess);
                          break;
                      
                      }
                    
                      
                  }
                props.updateUserCart(authUser.id, { currentBranch: currentBranch }, onSuccess)
        
            }else{
                switch (props.location.pathname) {
                    case '/':
                        props.fetchRandomPackages({branch: currentBranch, status: 'active'})
                        props.fetchFeaturedServices({ branch: currentBranch, status: 'active', featured: true });
                      break;
                    case '/estore':
                        const onSuccess = () => {
               
                        }
                        props.fetchServices({branch:currentBranch,type:props.location.state.type,status: 'active'},onSuccess);
                      break;
                  
                  }
            }
        }


  }, [currentBranch]);

    const logout = () => {
        props.logout(history)
        Swal.fire({
            icon: 'success',
            title: 'Logout Sucessfull',
            text: 'Thank You'
        })
       // dispatch({ type: "user/logout" })
       // history.push("/");
    }
    const handleBranchChange = (event) => {
      
        localStorage.setItem('currentBranch', event.target.value)
        setCurrentBranch(event.target.value)
       
      };

      const changeLanguage = (event) => {
        let lang = event.target.value;
        setCurrentLang(lang)
        Cookies.set('fj_lang', lang)
        i18n.changeLanguage(lang);
      };

     

    return (
        <>
            <section id="top_header">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-5 col-7">
                            <div className="top_header_left">
                                <p className='headp'><a className='text-white' href={"tel:"+t("phone")}><IoCallOutline/> {t("phone")}</a> | <a className='text-white' target='_blank' href="mailto:info@aecmc.com">info@aecmc.com</a></p>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-6 col-sm-7 col-5">
                            <div className="top_header_right">
                                
                                
                                    
                                        <ul className="right_list_fix">
                                        {/* <li className='d-none d-sm-none d-md-block'>
                                           <a href='https://www.mentalhealth.aecmc.com' target='_blank' className='headp mx-2 tpbtn'>{t('childsite')}</a>
                                           </li> */}

                                           <li className='d-none d-sm-none d-md-block'>
                                           <p className='headp mx-2'>{t('openhours')}</p>
                                           </li>

                                           <li>
                                            <a href="https://www.facebook.com/adamandevecosmeticmedicalcenter/" target='_blank'>
                                            <img className='social-icon-circle' src={fb}/>
                                            </a>

                                            <a href="http://www.twitter.com/" target='_blank'>
                                            <img className='social-icon-circle' src={twitter}/>
                                            </a>
                                            {/* <a href="https://www.linkedin.com/" target='_blank' className='ml-2'>
                                            <img className='social-icon-circle' src={linked}/>
                                            </a> */}
                                            <a href="https://www.instagram.com/adamandeve_aecmc/" target='_blank' >
                                            <img className='social-icon-circle' src={insta}/>
                                            </a>
                                            <a href="https://www.youtube.com/channel/UCjkpOCn2aIhUb6HS0msenkw" target='_blank' >
                                            <img className='social-icon-circle' src={yt}/>
                                            </a>

                                        </li>

                                           {/* {props.branches.length >0 && <li><i className="fa fa-medkit"></i> 

                                            <select className="medical-center-input" onChange={handleBranchChange} value={currentBranch} >
                                            {props.branches.map((data, index) => (<option key={index} value={data.id}>{data.name}</option>))}
                                            </select>
                                            
                                            </li>}

                                            <li><i className="fa fa-globe"></i>  
                                            <select className="lang-center-input" onChange={changeLanguage} value={currentLang}>
                                            <option value="en">{t('english')}</option>
                                            <option value="ar">{t('arabic')}</option>
                                          
                                            </select></li> */}

                                        

                                           {/* {!user && <li><Link to="/login"><i className="fa fa-user"></i> {t('login')}</Link></li>}
                                           {!user && <li><Link to="/register"><i className="fa fa-lock"></i> {t('signup')}</Link></li>}

                                           {user && <li className="after_login"><img src={avater} alt="avater" /> {user.firstName+' '+user.lastName} <i className="fa fa-angle-down"></i>
                                                <ul className="custom_dropdown">
                                                    <li><Link to="/my-account"><i className="fa fa-tachometer"></i> Dashboard</Link></li>
                                                    <li><Link to="/my-account/customer-order"><i className="fa fa-cubes"></i> My Orders</Link></li>
                                                    <li><Link to="#!" onClick={() => { logout() }} ><i className="fa fa-sign-out"></i> Logout</Link></li>
                                                </ul>
                                            </li>} */}
                                        </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TopHeader